<template>
  <div>
    <v-container>
      <v-card v-if="!contatoSalvo">
        <div class="text-center">
					<v-sheet color="white" class="pt-5 pb-5">
						<img src="@/assets/img/logo.svg" alt="CETABA" height="120" />
					</v-sheet>
				</div>
        <v-card-title>
          <span class="headline">Vincule seu registro a uma empresa</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form">
            <v-row v-if="pessoa.id==null">
              <v-col cols="12" md="6" lg="4">
                <v-text-field v-model="pessoa.cpf" label="Cpf*" :rules="[rules.required, rules.cpf]" v-mask="'###.###.###-##'" ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="pessoa.id!=null">
              <v-col cols="12" class="mt-4">
                <h1>Olá {{ pessoa.nome }}</h1>
                <p class="mt-2">CPF {{ pessoa.cpf }}</p>
              </v-col>

              <v-col cols="12" sm="6">
									<v-autocomplete
                    v-model="empresaSelected"
                    :items="empresaList"
                    item-text="nome_fantasia"
                    item-value="id"
                    label="Empresa"
                    placeholder="Selecione uma empresa"
                    return-object
                    id="nome_fantasia"
										:rules="[rules.required]"
                  >
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <v-list-item-title>
													{{ data.item.nome_fantasia }}
												</v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
								</v-col>
								<v-col cols="12" sm="6">
									<v-autocomplete
                    v-model="cargoSelected"
                    :items="cargoList"
                    item-text="cargo"
                    item-value="id"
                    label="Cargo"
                    placeholder="Selecione um cargo"
                    return-object
                    id="cargo"
										:rules="[rules.required]"
                  >
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <v-list-item-title>
													{{ data.item.cargo }}
												</v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
								</v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" v-if="pessoa.id==null" @click="getPessoaByCpf"><v-icon left>fas fa-search</v-icon> Buscar registro</v-btn>
          <v-btn color="green darken-1" v-if="pessoa.id!=null" dark @click="save"><v-icon left>fas fa-save</v-icon> Salvar e enviar</v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="contatoSalvo" color="success" dark>
        <div class="text-center">
					<v-sheet color="white" class="pt-5 pb-4">
						<img src="@/assets/img/logo.svg" alt="CETABA" height="150" />
					</v-sheet>
				</div>
        <v-card-text class="text-center">
          <h1 class="mb-6">Vínculo realizado com sucesso!</h1>
          <h3>Muito obrigado por fazer parte da nossa história</h3>
        </v-card-text>
      </v-card>

      <v-card v-if="pessoa.id!=null" class="mt-4">
        <v-card-text>
          <p class="title">Não encontrou sua empresa ou seu cargo?</p>
          <p class="subtitle-1">Escreva uma sujestão e iremos verificar a possibilidade de inserção em nosso sistema!</p>
        </v-card-text>
        <v-card-text v-if="!sujestaoSalvo">
          <v-form ref="form2">
            <v-row>
              <v-col cols="12" sm="3">
                <v-checkbox
                  v-model="sujestaoEmpresa"
                  label="Sujestão de empresa"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" sm="3">
                <v-checkbox
                  v-model="sujestaoCargo"
                  label="Sujestão de cargo"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="sujestao" label="Escreva sua sujestão" :rules="[rules.required]"></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-text v-else >
          <h2 class="green--text">
            Sujestão cadastrada com sucesso :)
          </h2>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" dark @click="saveSujestao()" v-if="!sujestaoSalvo"><v-icon left>fas fa-save</v-icon> Salvar e enviar</v-btn>
          <v-btn color="primary blue-1" dark @click="sujestaoSalvo=false" v-else><v-icon left>fas fa-arrow-left</v-icon> Cadastrar outra sujestão</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>

	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
    return {
			pessoa: {
        id: null,
				nome: null,
				cpf: null,
      },
      empresaList: [],
      empresaSelected: null,
      cargoList: [],
      cargoSelected: null,
      contatoSalvo: false,

			sujestao: null,
      sujestaoSalvo: false,
      sujestaoEmpresa: true,
      sujestaoCargo: false
		}
  },
  computed: {
    ...mapState(
      ['rules']
    ),
  },
  watch: {
    sujestaoEmpresa(val) { this.sujestaoCargo = !val },
		sujestaoCargo(val) { this.sujestaoEmpresa = !val },
  },
  methods: {
    getPessoaByCpf(){
      if(this.$refs.form.validate()){
        let formData = new FormData()
        formData.append('frase', 'Cadastro pelo cliente')
        formData.append('function', 'pessoa')
        formData.append('cpf', this.pessoa.cpf)
        let vd = this
        this.$axiosPost.post('cadastro/empresa.php', formData)
        .then(function (response) {
          if(response.data.error === 0){
            vd.pessoa = response.data.pessoa
            vd.getDadosSelects()
          }else{
            vd.$store.dispatch('errorServer', { data: response.data, destino: vd.$route.path } )
          }
        }).catch(function(response){
          console.log('ERRO!! '+response);
        })
      }
    },
    getDadosSelects(){
      let formData = new FormData()
      formData.append('frase', 'Cadastro pelo cliente')
      formData.append('function', 'selects')
      formData.append('cpf', this.pessoa.cpf)
      let vd = this
      this.$axiosPost.post('cadastro/empresa.php', formData)
			.then(function (response) {
        if(response.data.error === 0){
          vd.empresaList = response.data.empresas
          vd.cargoList = response.data.cargos
        }else{
          vd.$store.dispatch('errorServer', { data: response.data, destino: vd.$route.path } )
        }
			}).catch(function(response){
        console.log('ERRO!! '+response);
      })
    },

    save(){
      if(this.$refs.form.validate()){
        let formData = new FormData()
        formData.append('frase', 'Cadastro pelo cliente')
        formData.append('function', 'pessoa_empresas')
        formData.append('cpf', this.pessoa.cpf)
        formData.append('pessoa_id', this.pessoa.id)
        formData.append('empresa_id', this.empresaSelected.id)
        formData.append('cargo_id', this.cargoSelected.id)
        let vd = this
        this.$axiosPost.post('cadastro/empresa.php', formData)
        .then(function (response) {
          if(response.data.error === 0){
            vd.contatoSalvo = true
          }else{
            vd.$store.dispatch('errorServer', { data: response.data, destino: vd.$route.path } )
          }
        }).catch(function(response){
          console.log('ERRO!! '+response);
        })
      }
    },
    saveSujestao(){
      if(this.$refs.form2.validate()){
        let formData = new FormData()
        formData.append('frase', 'Cadastro pelo cliente')
        formData.append('function', 'sujestao')
        formData.append('cpf', this.pessoa.cpf)
        formData.append('pessoa_id', this.pessoa.id)
        formData.append('empresa', this.sujestaoEmpresa?1:0)
        formData.append('cargo', this.sujestaoCargo?1:0)
        formData.append('sujestao', this.sujestao)
        let vd = this
        this.$axiosPost.post('cadastro/empresa.php', formData)
        .then(function (response) {
          if(response.data.error === 0){
            vd.sujestaoSalvo = true
          }else{
            vd.$store.dispatch('errorServer', { data: response.data, destino: vd.$route.path } )
          }
        }).catch(function(response){
          console.log('ERRO!! '+response);
        })
      }
    },
  },
}
</script>